import { useMemo } from 'react';

import AlertContainer from '../components/AlertContainer';
import ConditionEvaluator from '../components/utilityComponents/ConditionEvaluator';
import QuestionLibraryMapper from './QuestionLibraryMapper';

type ResolutionMapperProps = {
  field?: Record<string, any>;
  resolution?: any;
  allFields?: Record<string, any>;
  isParentShowing?: boolean;
  style?: React.CSSProperties;
};

/**
 * @typedef {object} ResolutionMapperProps
 * @property {import('../types/question').Resolution} resolution
 *
 * @param {ResolutionMapperProps} props
 * @returns {JSX.Element}
 */

export default function ResolutionMapper({
  resolution,
  isParentShowing = true,
}: Readonly<ResolutionMapperProps>) {
  const resolutionMapper = {
    followUpQuestion: (
      <QuestionLibraryMapper
        component={resolution.type ? resolution : {}}
        isParentShowing={isParentShowing}
      />
    ),
    alert: <AlertContainer resolution={resolution} />,
  };

  const component = useMemo(
    () =>
      resolutionMapper[resolution.resolutionType] ?? (
        <p>
          No resolution of type <strong>{resolution.resolutionType}</strong>
        </p>
      ),
    // eslint-disable-next-line @eslint-react/exhaustive-deps
    [resolution.resolutionType],
  );

  return (
    <ConditionEvaluator conditions={resolution.conditions}>
      {component}
    </ConditionEvaluator>
  );
}
